import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { usePayment } from '../contexts/PaymentContext';

const PaymentCancel = () => {
  const { resetPaymentState } = usePayment();
  
  // Reset payment state when component mounts
  useEffect(() => {
    resetPaymentState();
  }, [resetPaymentState]);
  
  return (
    <div className="max-w-3xl mx-auto px-4 py-16 text-center">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 md:p-12">
        <div className="flex justify-center mb-6">
          <XCircle size={80} className="text-red-500" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Cancelled</h1>
        
        <p className="text-gray-600 mb-8 text-lg">
          Your payment process was cancelled. No charges have been made to your account.
        </p>
        
        <div className="bg-gray-50 rounded-lg p-6 mb-8 text-left">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Common reasons for cancellation:</h2>
          
          <ul className="space-y-3">
            <li className="flex items-start">
              <div className="h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                <span className="text-red-600">•</span>
              </div>
              <span className="text-gray-700">Payment information was incorrect</span>
            </li>
            <li className="flex items-start">
              <div className="h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                <span className="text-red-600">•</span>
              </div>
              <span className="text-gray-700">The payment process was manually cancelled</span>
            </li>
            <li className="flex items-start">
              <div className="h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                <span className="text-red-600">•</span>
              </div>
              <span className="text-gray-700">There was a technical issue with the payment processor</span>
            </li>
          </ul>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link 
            to="/checkout" 
            className="px-8 py-3 rounded-full font-medium bg-primary-600 text-white hover:bg-primary-700 transition-colors duration-200 shadow-md"
          >
            Try Again
          </Link>
          
          <Link 
            to="/support" 
            className="px-8 py-3 rounded-full font-medium bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 transition-colors duration-200"
          >
            Contact Support
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel; 